import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ChangePasswordComponent } from './layout/change-password/change-password.component';
import { AccountSettingsComponent } from './layout/account-settings/account-settings.component';
const routes: Routes = [

  { path: '', redirectTo: 'login', pathMatch: 'full' },
 
   { path:'', component: LoginComponent  },
 
  { path: 'dashboard',  loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.AdminModule) },
  { path: 'user-management',  loadChildren: () => import('./components/usermanagement/usermanagement.module').then(m => m.UsermanagementModule) },
  
  { path: 'change-password',  component: ChangePasswordComponent },
  
  { path: 'account-settings',  component: AccountSettingsComponent },

  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
